import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import useErrorStore from "../../data/stores/errorStore";
import { MainToolComponent } from "../new-tool";
import { apiCall } from "../../data/useFetcher";
import { toast } from "react-toastify";

const UpdateTool = () => {
	const navigate = useNavigate(),
		[newD, setNewD] = useState(null),
		[getSearch] = useSearchParams();

	let [preloading, setPreLoading] = useState(true),
		{ returnErrors } = useErrorStore(),
		searchChecker =
			getSearch?.get("contactEmailAddress") &&
			getSearch?.get("requestId") &&
			getSearch?.get("tool");

	useEffect(() => {
		if (searchChecker) {
			const onValidateSubmit = async () => {
				let { response, errArr, errMsg } = await apiCall({
					type: "get",
					url: `/api/v1/tools/new-request/manage-new-request?contactEmailAddress=${getSearch?.get(
						"contactEmailAddress"
					)}&requestId=${getSearch?.get("requestId")}&tool=${getSearch?.get(
						"tool"
					)}`,
					noToast: true,
				});
				console.log({ response, errArr, errMsg });
				if (errArr) {
					setPreLoading(false);
					returnErrors(errArr);
					navigate("/");
					return;
				}
				if (errMsg) {
					setPreLoading(false);
					toast.error(errMsg);
					navigate("/");
					return;
				}
				setPreLoading(false);
				if (response) {
					console.log({ response }, "new-tool");
					let newD = response?.data || response,
						updateT = response?.tool,
						updReset: any = {};
					if (newD?.contactEmailAddress)
						updReset.contactEmailAddress = newD?.contactEmailAddress;
					if (newD?.toolName) updReset.toolName = newD?.toolName;
					if (newD?.website) updReset.website = newD?.website;
					if (newD?.description) updReset.description = newD?.description;
					if (newD?.organizationName)
						updReset.organizationName = newD?.organizationName;

					if (updateT) {
						if (updateT?.contactEmailAddress)
							updReset.contactEmailAddress = updateT?.contactEmailAddress;
						if (updateT?.toolName) updReset.toolName = updateT?.toolName;
						if (updateT?.website) updReset.website = updateT?.website;
						if (updateT?.description)
							updReset.description = updateT?.description;
						if (updateT?.toolCreatedBy)
							updReset.toolCreatedBy = updateT?.toolCreatedBy;
						if (updateT?.toolOwnerAddress)
							updReset.toolOwnerAddress = updateT?.toolOwnerAddress;
						if (updateT?.logo) updReset.logo = updateT?.logo;
					}
					if (Object.keys(updReset)?.length > 0)
						setNewD((prev: any) => {
							return {
								...prev,
								basic: updReset,
							};
						});
					let newSelect: any = {};

					if (newD?.region) newSelect.REGION = [newD?.region];
					// setSelection((prev: any) => {
					// 	return { ...prev, REGION: [newD?.region] };
					// });
					if (newD?.country) newSelect.COUNTRY = [newD?.country];
					// setSelection((prev: any) => {
					// 	return { ...prev, COUNTRY: [newD?.country] };
					// });
					if (newD?.toolCategory)
						newSelect["APPLICATION LEVEL"] = newD?.toolCategory;

					if (updateT?.toolSelection?.length > 0) {
						updateT?.toolSelection?.map(
							(it: any) =>
								(newSelect[it?.category] =
									it?.category === "APPLICATION LEVEL"
										? it?.data?.[0]
										: it?.data)
						);
					}

					if (Object.keys(newSelect)?.length > 0) {
						setNewD((prev: any) => {
							return {
								...prev,
								select: newSelect,
							};
						});
					}

					let otherProps = {
						kpiSelection: updateT?.kpiSelection,
						resources: updateT?.resources,
						utilities: updateT?.utilities,
					};
					if (Object.keys(otherProps)?.length > 0) {
						setNewD((prev: any) => {
							return {
								...prev,
								others: otherProps,
							};
						});
					}

					return;
				}
				setPreLoading(false);
			};
			onValidateSubmit();
		} else {
			navigate("/");
			setPreLoading(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [getSearch, navigate]);

	if (preloading) return <>Loading...</>;

	return (
		<MainToolComponent
			newD={newD?.basic}
			newSelect={newD?.select}
			others={newD?.others}
		/>
	);
};

export default UpdateTool;
